import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  color: theme.color.light,
  fontSize: theme.fontSize.medium,
  margin: `0 ${theme.margin.small}`,
  padding: `0 ${theme.margin.large}`,
  alignContent: 'center',
  height: theme.margin.xxlarge,
  direction: theme.origDirection,
});

const Header = ({ children }) => {
  const { css } = useFela();

  return (
    <h3 className={css(rules)}>
      {children}
    </h3>
  );
};

Header.propTypes = {
  children: PropTypes.node,
};

export default React.memo(Header);
